import { useEffect, useState } from 'react';
import { canUseDOM } from '@/app/common/utils/canUseDOM';

function checkFlexGapSupport() {
  if (!canUseDOM) return false;

  const flex = document.createElement('div');
  flex.style.display = 'flex';
  flex.style.flexDirection = 'column';
  flex.style.rowGap = '1px';
  flex.style.position = 'absolute';

  flex.appendChild(document.createElement('div'));
  flex.appendChild(document.createElement('div'));
  document?.body?.appendChild(flex);

  const isSupported = flex.scrollHeight === 1;

  if (document?.body?.contains(flex)) {
    flex.remove();
  }

  return isSupported;
}

export const useFlex = () => {
  const [isFlexSupported, setIsFlexSupported] = useState(checkFlexGapSupport());

  useEffect(() => {
    setIsFlexSupported(checkFlexGapSupport());
  }, []);

  useEffect(() => {
    const body = document.querySelector('body');
    if (isFlexSupported) {
      // body.classList.add('flex-supported');
      body?.classList.remove('flex-unsupported');
    } else {
      body?.classList.add('flex-unsupported');
      // body.classList.remove('flex-supported');
    }
  }, [isFlexSupported]);

  return isFlexSupported;
};
